import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export default function DeveloperInfo({children}) {
  return (
    <Stack sx={{width: '100%'}} spacing={2}>
      <Alert severity="info">[For Developers]: {children}</Alert>
    </Stack>
  );
}
